import { appFlags } from './appFlags';

function useApp() {
  return appFlags(import.meta.env.VITE_APP_NAME);
}

export default useApp;
